import { findPatientSummaryByNumber } from '../../services/findPatientSummaryByNumber'

/**
 * The physician to use for PATIENT actions (updatePatient, patient default
 * details, delete OPA, cancellation saga, resupply access form).
 *
 * Oracle rejects patient calls made under any physician other than the
 * patient's current one, and the order line physician is an order fact that
 * can differ (Data Platform, ~33% of PROD orders). It is never used here:
 * 1. router state physicianId (set when arriving from patient/programme pages)
 * 2. the patient's current physician from the patient summary
 * Undefined means the caller must not make the patient call.
 */
export const resolvePatientPhysicianId = async ({
  locationPhysicianId,
  patientNumber
}: {
  locationPhysicianId?: string | number | null
  patientNumber?: string | null
}): Promise<string | undefined> => {
  const fromState =
    locationPhysicianId != null ? String(locationPhysicianId).trim() : ''
  if (fromState) {
    return fromState
  }

  try {
    const patient = await findPatientSummaryByNumber(patientNumber ?? undefined)
    return patient?.physicianId ? String(patient.physicianId) : undefined
  } catch {
    // The caller reports the unresolved physician; never fall back to the order line.
    return undefined
  }
}
